import styled from 'styled-components';

export const Content = styled.div`
  p {
    overflow-wrap: anywhere;
  }
`;
